import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import default_pro from '../../Assets/Images/pro.png'
// import './styles.css';

// import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Image } from 'antd';
import API from '../../ApiService/ApiService';
import styled from 'styled-components';
export default function Slider({image}) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const api = new API();
   return (
    <SliderSection>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="main"
      >
        {
          image?.map((e,i)=>{
            return (
              <SwiperSlide key={i} className='slide_main'>
                <Image src={e.image_path?api.apiUrl+e.image_path:default_pro} />
              </SwiperSlide>
            )
          })
        }
        
        
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={6}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="thump"
      >
       {
          image?.map((e,i)=>{
            return (
              <SwiperSlide key={i} className='slide_thump'>
                <img src={e.image_path?api.apiUrl+e.image_path:default_pro} />
              </SwiperSlide>
            )
          })
        }
        
      </Swiper>
    </SliderSection>
  );
};


const SliderSection = styled.section`
  
.slide_main {
  border: 1px solid #e9e9e9;
  /* box-shadow: 0 0 15px #000; */
}
.main img.ant-image-img {
  width: 100% !important;
}
.main .ant-image {
  width: 100%;
}

.slide_thump {
  border: 1px solid #e9e9e9;
  /* box-shadow: 0 0 15px #000; */
  display: flex;
}
.main {
  /* padding: 15px; */
}
.thump {
  width: 100%;
  display: inline-block;
  margin: 15px 0 0 0;
}

.swiper-button-prev, .swiper-button-next {
  background: #C94142;
  border-radius: 5px;
  box-shadow: 0 0 10px rgb(0 0 0 / 30%);
}
.swiper-button-prev:after, .swiper-button-next:after {
  font-size: 16px;
  font-weight: 600;
}






`;
